import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ASSETS, RIVER } from "../../data/content";
import { FadeUp, MaskLineInView } from "./Reveal";

export const TheRiver = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section
      id="river"
      ref={ref}
      data-testid="river-section"
      className="relative bg-[#052e1e] py-12 lg:py-16 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        {/* Portrait photo — key visual, kept prominent */}
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_30px_60px_-25px_rgba(0,0,0,0.6)]">
            <motion.div style={{ y: imgY }} className="will-change-transform">
              <img
                src={ASSETS.river}
                alt="The river running through The Brook, at first light"
                loading="lazy"
                decoding="async"
                className="w-full h-[520px] sm:h-[640px] lg:h-[720px] object-cover object-[center_78%]"
              />
            </motion.div>
            {/* very light vignette so the photo remains bright and visible */}
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#052e1e]/25 via-transparent to-transparent" />
            <span className="absolute top-5 left-5 font-body text-[#ddb128] text-[11px] tracking-[0.4em] uppercase">
              {RIVER.label}
            </span>
          </div>
        </div>

        {/* Copy */}
        <div className="lg:col-span-6 order-1 lg:order-2">
          <FadeUp>
            <span className="font-body text-[#ddb128] text-[13px] tracking-[0.3em] uppercase">
              {RIVER.label}
            </span>
          </FadeUp>
          <h2 className="font-display text-[#f7f3e9] text-[52px] sm:text-7xl lg:text-[110px] leading-[1] mt-2 whitespace-pre-line">
            {RIVER.headline.split("\n").map((line, i) => (
              <MaskLineInView key={i} delay={i * 0.12}>
                {line}
              </MaskLineInView>
            ))}
          </h2>
          <div className="gold-rule w-24 my-4" />
          <div className="space-y-4 max-w-lg">
            {RIVER.lines.map((l, i) => (
              <FadeUp key={i} delay={i * 0.06}>
                <p
                  className={`font-body font-light leading-relaxed ${
                    i === 0
                      ? "text-[#ddb128] text-xl sm:text-2xl font-normal"
                      : "text-[#f7f3e9]/95 text-base sm:text-lg"
                  }`}
                >
                  {l}
                </p>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
